const currencies = [
  { code: 'EUR', symbol: '€' },
  { code: 'MKD', symbol: 'MKD' }
]

const titles = ['Mr', 'Mrs', 'Miss', 'Chd', 'Inf']
const round = (val) => { return Math.round(val * 100) / 100 }

export {
  currencies,
  titles,
  round
}
